import Utils from '@/utils/util';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { ReactComponent as Decrement } from '@/assets/img/decement.svg';
import { ReactComponent as Increment } from '@/assets/img/increment.svg';

type DefaultValues = {
  step: number;
  maxHours: number;
  enableInput?: boolean;
};
export type DurationPickerProps = {
  selectedDuration: number;
  onSelectDuration: (item: any) => void;
  defaultValues?: DefaultValues;
};

const STEP = 5;
const MAX_HRS = 120;

export const DurationPicker = ({
  selectedDuration,
  onSelectDuration,
  defaultValues,
}: DurationPickerProps) => {
  const [duration, setDuration] = useState(selectedDuration);
  const [step, setStep] = useState(defaultValues ? defaultValues.step : STEP);
  const [maxHours, setMaxHours] = useState(defaultValues ? defaultValues.maxHours : MAX_HRS);

  useEffect(() => {
    if (defaultValues) {
      setStep(defaultValues.step);
      setMaxHours(defaultValues.maxHours);
    }
  }, [defaultValues]);

  const incrementDuration = () => {
    setDuration(duration + step);
    onSelectDuration(duration + step);
  };

  const decrementDuration = () => {
    if (duration >= step) {
      setDuration(duration - step);
      onSelectDuration(duration - step);
    }
  };

  useEffect(() => setDuration(selectedDuration), [selectedDuration]);

  const onDurationChange = (e: any) => {
    const dur =
      defaultValues?.maxHours && parseFloat(e.target.value) > defaultValues?.maxHours
        ? 5
        : parseFloat(e.target.value);
    setDuration(dur);
    onSelectDuration(dur);
  };
  return (
    <div className="duration-picker flex justify-center items-center">
      <button
        disabled={duration <= step}
        className="flex justify-center items-center disabled:opacity-70 disabled:cursor-not-allowed focus:outline-none hover:opacity-80 petsked-button button-dark no-wrap rounded-full w-11 h-11"
        onClick={decrementDuration}
      >
        <Decrement />
      </button>
      {defaultValues?.enableInput ? (
        <div className="petsked-form">
          <input
            id="price"
            type="number"
            name="input-name"
            value={duration}
            onChange={onDurationChange}
            maxLength={1}
            placeholder="0"
          />
          <span className="helper">pets</span>
        </div>
      ) : (
        <div className="pet-detail-desc text-center">{Utils.getDuration(duration)}</div>
      )}
      <button
        disabled={duration >= maxHours}
        className="flex justify-center items-center disabled:opacity-70 disabled:cursor-not-allowed focus:outline-none hover:opacity-80 petsked-button button-dark no-wrap rounded-full w-11 h-11"
        onClick={incrementDuration}
      >
        <Increment />
      </button>
    </div>
  );
};
